/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { useState } from 'react';
import { Box, Button, DialogActions, Typography } from '@mui/material';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer';
import { toast } from 'react-toastify';
 import { deleteKeyCloakUser } from '../../../../../../services/keycloak/keycloak';

const DeleteKeycloakUser = ({ username }) => {
    const [open, setOpen] = useState(false);

    // Handle open/close dialog
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    const handleSubmit = async () => {
        try {
            // if your API expects an object, wrap it:
            await deleteKeyCloakUser({ username, realm: "getchkd" });
            toast.success('User was deleted successfully');

             toast.success(`User "${username}" was dropped successfully`);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message || 'Drop failed');
        } finally {
            handleClose();
        }
    };
    return (
        <>
            <Button variant="contained" color="error" style={{ float: 'right' }} onClick={handleOpen}>Delete</Button>
            {/* Dialog for Adding MApping */}
            <DialogContainer open={open} handleClose={handleClose}>
                <Box sx={{ mt: 1 }}>
                    <Typography variant="h3" align="center" gutterBottom>
                        Confirm Drop
                    </Typography>
                    <Typography align="center" variant="h3" sx={{ mb: 3 }}>
                        Are you sure you want to drop user <strong>{username}</strong>?
                    </Typography>

                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={handleSubmit}
                        >
                            Confirm
                        </Button>
                    </DialogActions>
                </Box>
            </DialogContainer>
        </>
    )

}

export default DeleteKeycloakUser;
